import Home from '../pages/customer/Home';
import MakePayment from '../pages/customer/MakePayment';
import PlaceOrder from '../pages/customer/PlaceOrder';
import RequestBill from '../pages/customer/RequestBill';
import TrackOrder from '../pages/customer/TrackOrder';
import ViewMenu from '../pages/customer/ViewMenu';
import LandingPage from '../pages/LandingPage';
import CustomerDetails from '../pages/customer/customerDetails';
import MyOrder from '../pages/customer/MyOrder';
import JoinCart from '../pages/customer/JoinCart';
import Payment from '../pages/customer/Payment';

const CustomerRoutes = [
  { path: '/', element: <LandingPage />, exact: true },
  { path: '/customer/details', element: <CustomerDetails />, exact:true},
  { path: '/customer/payment', element: <Payment />, exact:true},
  { path: '/customer/join-cart', element: <JoinCart />, exact:true},
  { path: '/customer/home', element: <Home />, exact: true },
  { path: '/customer/payments', element: <MakePayment />, exact: true },
  { path: '/customer/MyOrder', element: <MyOrder />, exact: true },
  { path: '/customer/order', element: <PlaceOrder />, exact: true },
  { path: '/customer/bill', element: <RequestBill />, exact: true },
  { path: '/customer/track-order', element: <TrackOrder />, exact: true },
  { path: '/customer/menu', element: <ViewMenu />, exact: true },
];

export default CustomerRoutes;